<template>
    <div class="confirm-container">
        <!-- 配置信息 -->
        <div class="instance-item">
            <div class="instance-item-left">
                <!-- <i class="icon-system-settings-o instance-item-icon"></i> -->
                <span>{{$t('配置信息')}}</span>
            </div>
            <div class="instance-item-right">
                <Row>
                    <Col span="8">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('计费类型')}}：</span>
                        <span class="value"
                              :title="defaultChargeTypeData[data.billingType]||'--'">{{defaultChargeTypeData[data.billingType]||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('套餐类型')}}：</span>
                        <span class="value"
                              :title="availableZonesList[data.type]||'--'">{{availableZonesList[data.type]||'--'}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('产品')}}：</span>
                        <span class="value"
                              :title="data.productName">{{data.productName}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('规格')}}：</span>
                        <span class="value"
                              :title="JSON.parse(data.specValue)[0].specName">{{JSON.parse(data.specValue)[0].specName}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('购买数量')}}：</span>
                        <span class="value"
                              :title="data.quantity">{{data.quantity}}</span>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="show-item mat-top5">
                        <span class="title">{{$t('购买时长')}}：</span>
                        <span class="value"
                              :title="data.times">{{data.times}}</span>
                    </div>
                    </Col>
                </Row>

            </div>
        </div>
        <!-- <discountmodal ref="discountmodal"
                       :titleTxt="$t('确定要继续购买吗？') "
                       :contentTxt="$t('您使用的优惠券金额大于订单金额，超出的优惠金额将不退还。')"
                       @modalFun="modalFun"></discountmodal> -->
    </div>
</template>

<script>
// import { formatDateTime } from '@/service/utils'
// import API from '@/service/api.js'
// import discountmodal from '@/views/portal/application/components/discountmodal.vue'
import innerServiceMixin from '@/mixin/innerServiceMixin.js'
export default {
    name: 'InfoConfirm',
    props: ['submitData'],
    components: {
        // discountmodal
    },
    data () {
        return {
            data: this.submitData.zeroData,
            formData: this.submitData.oneData,
            couponData: [],
            rules: {},
            templatesData: this.submitData.templatesData,

            availableZonesList: { discount: '折扣包', resouce: '资源包' },
            defaultChargeTypeData: { PrePaid: '包年包月' }
        }
    },
    created () {
        // if (this.formData.isCoupon) {
        //     this.changeCoupon()
        // } else {
        // this.formData.isCoupon = false
        // this.formData.couponId = null
        // this.formData.discount = null
        // }
        // this.inquiry()
    },
    mixins: [innerServiceMixin],
    computed: {
        // tradePrice () {
        //     return this.submitData.tradePrice
        // }
    },
    methods: {

    }
}
</script>

<style lang="less" scoped>
.confirm-container {
    .instance-item {
        display: flex;
        padding-top: 20px;
        margin-bottom: 10px;
        // border-bottom: 1px dashed #e9e9e9;
        background: #fff;
        .instance-item-left {
            width: 150px;
            text-align: left;
            padding-top: 3px;
            padding-left: 40px;
            font-size: 12px;
            font-weight: 600;
            .instance-item-icon {
                position: relative;
                right: 6px;
                top: 2px;
                font-size: 14px;
            }
        }
        .instance-item-right {
            width: 850px;
            font-size: 12px;
            padding-right: 15px;
            .show-item {
                margin-bottom: 20px;
                .title {
                    display: inline-block;
                    width: 100px;
                    color: #999;
                    text-align: right;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                    overflow: hidden;
                    vertical-align: middle;
                }
                .value {
                    display: inline-block;
                    width: calc(~'100% - 100px');
                    position: relative;
                    top: 5px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
        }
    }
}
</style>
